import axios from 'axios';
import { MessageBox } from 'element-ui'
axios.defaults.withCredentials = true;


function encodeFormData(data) { //将参数转换为 Form Data
    if (!data) return ""; //一直返回字符串
    var pairs = []; //用于保存名值对
    for (var name in data) {
        if (!data.hasOwnProperty(name)) {
            continue; //跳过继承属性
        }
        if (typeof data[name] === "function") {
            continue; //跳过方法
        }
        var value = data[name] !=null? data[name].toString():""; //把值转换成字符串
        name = encodeURIComponent(name.replace("%20", "+")); //编码名字
        value = encodeURIComponent(value.replace("%20", "+")); //编码值
        pairs.push(name + "=" + value); // 存入名值对
    }
    return pairs.join('&'); //返回使用'&'连接的名值对
}

function apiPath(url) {
    var apiUrl = url;
    if (url.substr(0, 1) != '/') {
        apiUrl = API_ROOT_PATH + url;
    }

    if (apiUrl.indexOf('__ajax') == -1) {
        if (apiUrl.indexOf('?') != -1) {
            apiUrl = apiUrl + '&__ajax=ok';
        } else {
            apiUrl = apiUrl + '?__ajax=ok';
        }
    }

    var timeOffset = Math.floor(new Date().getTimezoneOffset() / 60);
    timeOffset = -timeOffset;
    apiUrl = apiUrl + '&timeOffset=' + timeOffset;

    return apiUrl;
}
function showAlert(msg, code) {
    MessageBox({
        title: '错误',
        type: 'error',
        message: msg,
        confirmButtonText: '确定',
        closeOnClickModal: false,
        customClass: 'zZindex',
        callback: action => {
            // // console.log(action,code)
            if (action == "confirm") {
                if (code == 20401) {
                    location.href = '/Login';
                    // // console.log("A")
                }
            } else { }
        }
    })
}

let domain=""; //api域名(在config/index.js里面配置解决跨域问题)
function axiosPost(url, params, contentType) {
    let loginData=JSON.parse(sessionStorage.getItem('loginData')?sessionStorage.getItem('loginData'):null);
    if (process.env.NODE_ENV === 'production') {
        domain='https://adminapi.ci-ads.com'
    }
    let _url = domain + apiPath(url);
    let header = null;
    if (contentType == "JSON") {
        header={ headers: { 'Content-Type': 'application/json' }, withCredentials: true,timeout: 100000000 };
        params = JSON.stringify(params);
    } else {
        header = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, withCredentials: true ,timeout: 100000000 };
        params = encodeFormData(params);
    }
    if(loginData){
        header.headers.Authorization=loginData.token;
    }
    return new Promise((resolve, reject) => {
        axios.post(_url, params, header).then(result => {
            let data = result.data;
            if (data.code == 0) {
                resolve(data)
            } else {
                if (data.data) {
                    showAlert(data.data[0], data.code);
                } else {
                    showAlert(data.msg, data.code);
                }
            }
        }).catch(function (err) {
            reject(err)
        })
    })
}
function axiosGet(url, params) {
    let loginData=JSON.parse(sessionStorage.getItem('loginData')?sessionStorage.getItem('loginData'):null);
    if (process.env.NODE_ENV === 'production') {
        domain = 'https://adminapi.ci-ads.com';
    }
    let _url = domain + url;
    let headers={
        'Content-Type': 'application/x-www-form-urlencoded'
    }
    if(loginData){
        headers.Authorization=loginData.token;
    }
    // console.log(headers);
    return new Promise((resolve) => {
        axios.get(_url, {
            withCredentials: true,
            credentials: 'include',
            headers: headers,
            params: params
        }).then(function (response) {
            if (response.data.code == 0) {
                resolve(response.data);
            } else {
                showAlert(response.data.msg, response.data.code);
            }
        });
    });
}
export { axiosPost,axiosGet}



// WEBPACK FOOTER //
// ./src/assets/ajaxFn.js